module.exports = __webpack_public_path__ + "static/media/tele1.0d91e0f0.png";